'use client';

import { SideId } from '@wareena/grid-battles-entity/game/codebook/side';
import convertMapToScenarioFormat from '@wareena/grid-battles-engine/services/map/convertMapToScenarioFormat';
import createMap from '@wareena/grid-battles-engine/services/map/createMap';
import TutorialGameMap from '@local/tutorial/ui/TutorialGameMap';
import {
    Game,
    GameState,
    Player,
    Scenario,
} from '@wareena/grid-battles-engine/gameStateMachine/types';
import createUnit from '@wareena/grid-battles-engine/services/unit/unitFactory';
import { UnitTypeId } from '@wareena/grid-battles-entity/game/codebook/unitTypes';
import { ScenarioHexWithId } from '@wareena/grid-battles-entity/scenario/entity/scenario';

export default function ExampleEnemy() {
    const playerA: Player = {
        id: 1,
        side: SideId.A,
    };

    const playerB: Player = {
        id: 2,
        side: SideId.B,
    };

    const map = { cols: 5, rows: 4 };
    const mapHexes = createMap(map.cols, map.rows);

    const scenario: Scenario & {
        hexSize: number;
        hasFlatTop: boolean;
        hasOffsetOnFirstLine: boolean;
        hexes: ScenarioHexWithId[][];
    } = {
        startingSide: SideId.A,
        victoryConditions: 5,
        activationsPerTurn: 3,
        width: map.cols,
        height: map.rows,
        hexSize: 50,
        hasFlatTop: false,
        hasOffsetOnFirstLine: false,
        hexes: convertMapToScenarioFormat(mapHexes),
    };

    const state: GameState = {
        stateName: 'selectingForActivation',
        round: 1,
        units: [
            createUnit(UnitTypeId.Axeman, { id: 1, position: { column: 0, row: 3 } }),
            createUnit(UnitTypeId.Swordman, { id: 2, position: { column: 1, row: 3 } }),
            createUnit(UnitTypeId.Pikeman, { id: 3, position: { column: 2, row: 3 } }),
            createUnit(UnitTypeId.Archer, { id: 4, position: { column: 3, row: 3 } }),
            createUnit(UnitTypeId.Knight, { id: 5, position: { column: 4, row: 3 } }),
            createUnit(UnitTypeId.Axeman, {
                id: 11,
                position: { column: 0, row: 0 },
                side: SideId.B,
            }),
            createUnit(UnitTypeId.Swordman, {
                id: 12,
                position: { column: 1, row: 0 },
                side: SideId.B,
            }),
            createUnit(UnitTypeId.Pikeman, {
                id: 13,
                position: { column: 2, row: 0 },
                side: SideId.B,
            }),
            createUnit(UnitTypeId.Archer, {
                id: 14,
                position: { column: 3, row: 0 },
                side: SideId.B,
            }),
            createUnit(UnitTypeId.Knight, {
                id: 15,
                position: { column: 4, row: 0 },
                side: SideId.B,
            }),
        ],
        activeSide: playerA.side,
        unitsSelectedForActivation: [],
        victoryPoints: [],
    };

    const game: Game = {
        hexes: mapHexes,
        players: [playerA, playerB],
    };

    return (
        <TutorialGameMap
            scenario={scenario}
            state={state}
            game={game}
            checkEndOfAnExample={(state) => state.stateName !== 'selectingForActivation'}
        />
    );
}
